import { TextField, IconButton, Button, InputAdornment } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    getProjectNameOfField,
    isSystemField,
    onCloseFieldExpandMore,
    isShowDuplicateButton,
    getOrgName
} from '@/component/formManagement/handler/FieldListHandler';
import SettingFormDev from '@/component/formManagement/SettingFormDev';
import {
    updateParentFieldList,
    onChangeFieldName,
    isEditField,
    validateMaxLengthOfTextField,
    validateMinLengthOfTextField,
    isFieldError,
    getErrorByField,
    updateFieldListOnchangeData,
    getNumberFormStrings,
    isUseFieldInForm,
    updateFormMinNumber,
    updateFormMaxNumber,
    isAddNewField,
    isPermissionDeleteField,
    validateAddFieldNameCustom,
    getIconFieldByTypeField,
    onChangeFieldNameREF,
    isDisplayOptionShareField
} from '../handler/CommonHandler';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';
import { removeCurrentGUIAddField, duplicateField } from '../handler/FieldListHandler';
import ShareField from '../ShareField';
import FieldIdCommon from './FieldIdCommon';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function AddFieldText(props) {
    // Atom
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);
    const isOpenMoreActionPopover = Boolean(moreActionPopover);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    // const currentFieldData = props.fieldAddList[indexAddField];
    const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);

    const [isUsingProject, setIsUsingProject] = useState(
        Utils.isEmpty(currentFieldData?.usingProjects)
            ? false
            : currentFieldData.usingProjects.includes(props.projectDetail.id)
    );

    const [isUsingForm, setIsUsingForm] = useState(
        Utils.isEmpty(currentFieldData?.isUsingForm) ? false : currentFieldData.isUsingForm
    );

    const fieldRef = useRef('');


    useEffect(() => {
        setCurrentFielData(props.fieldAddList[indexAddField]);
    }, [props.fieldAddList[indexAddField]]);

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm
    };

    /** handler enter text input name */
    const onEnterTextInputName = event => {
        let textValue = event.target.value;

        
        // if event diff enter then return
        if (event.key !== 'Enter') {
            return;
        }

        let isValidate = validateAddFieldNameCustom(textValue, argsAll);
        if(isValidate){
            if (props.isChangeData === false) props.setIsChangeData(true);
            return;
        }

        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);

        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;

        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    const onChangeMinLength = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let indexInFieldList = Utils.findIndexInArrayById(
            currentFieldData.id,
            argsAll.fieldListInState
        );
        let hasValue = cloneFieldAddList[indexAddField].hasValue;
        // let minLength = event.target.value ? Number(event.target.value) : '';
        let minLength = getNumberFormStrings('POSITIVE_INTEGER', event.target.value);

        let maxLength = cloneFieldAddList[indexAddField].structure.maxLength;
        let minCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.minLength
                : null;
        let maxCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.maxLength
                : null;

        let errors = cloneFieldAddList[indexAddField].errors
            ? cloneFieldAddList[indexAddField].errors
            : {};
        let validateMin = validateMinLengthOfTextField(minLength, maxLength, minCurrent, hasValue);
        errors.minLength = validateMin;

        //check maxLength
        let errorMaxLength = errors.maxLength;
        if (
            minLength <= maxLength &&
            errorMaxLength &&
            errorMaxLength.type === 'minLargerMaxError'
        ) {
            errors.maxLength = {};
        }

        cloneFieldAddList[indexAddField].errors = errors;
        cloneFieldAddList[indexAddField].structure.minLength = minLength;
        props.setFieldAddList(cloneFieldAddList);
        // if (Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentFieldData.name).length > 0 && props.isChangeData === false) {
            props.setIsChangeData(true);
        // }

        // validate input field
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
    };

    const onChangeMaxLength = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let indexInFieldList = Utils.findIndexInArrayById(
            currentFieldData.id,
            argsAll.fieldListInState
        );
        let hasValue = cloneFieldAddList[indexAddField].hasValue;
        // let maxLength = event.target.value ? Number(event.target.value) : null;
        let maxLength = getNumberFormStrings('POSITIVE_INTEGER', event.target.value);
        let minLength = cloneFieldAddList[indexAddField].structure.minLength;
        let maxCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.maxLength
                : null;
        let minCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.minLength
                : null;

        let errors = cloneFieldAddList[indexAddField].errors
            ? cloneFieldAddList[indexAddField].errors
            : {};
        let validateMax = validateMaxLengthOfTextField(maxLength, minLength, maxCurrent, hasValue);
        errors.maxLength = validateMax;

        //check minLength
        let errorMinLength = errors.minLength;
        if (
            minLength <= maxLength &&
            errorMinLength &&
            errorMinLength.type === 'minLargerMaxError'
        ) {
            errors.minLength = {};
        }

        cloneFieldAddList[indexAddField].errors = errors;
        cloneFieldAddList[indexAddField].structure.maxLength = maxLength;
        props.setFieldAddList(cloneFieldAddList);

        // validate input field
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
        props.setIsChangeData(true);
    };

    const onChangeInputFormat = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let inputFormat = event.target.value;
        cloneFieldAddList[indexAddField].structure.inputFormat = inputFormat;
        props.setFieldAddList(cloneFieldAddList);
        // if (Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentFieldData.name).length > 0 && props.isChangeData === false)
            props.setIsChangeData(true);
    };

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = {...currentFieldData};
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldDataClone, args);
        setCurrentFielData(currentFieldDataClone);
    }

    const renderCustomField = () => {
        return (
            <li
                id={currentFieldData.id}
                // ref={props.fieldRefList[props.currentUpdateField.id]}
                ref={fieldRef}
                className={
                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                        ? 'listField-li'
                        : 'listField-li background-color-usingForm'
                }
                style={{ width: '100%' }}
            >
                <div
                    className={
                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                            ? 'fieldSetting-info fieldSetting-info--changeForm'
                            : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                    }
                >
                    <div className="fieldSetting-thumb">
                        <img src="/assets/image/icon-field02.svg" alt="" />
                    </div>
                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name">
                            <div className="formCreate">
                                <TextField
                                    className="form-input-outlined"
                                    placeholder="フィールド名"
                                    onKeyPress={onEnterTextInputName}
                                   // onChange={e => onChangeFieldName(e, argsAll)}
                                    onChange={e => handleOnChangeFieldName(e, argsAll)}
                                    onBlur={e => onChangeFieldName(e, argsAll)}
                                    // onBlur={e => onBlurUpdateField(currentFieldData, argsAll)}
                                    defaultValue={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        currentFieldData.name
                                    )}
                                    error={isFieldError('name', currentFieldData)}
                                    helperText={getErrorByField('name', currentFieldData)}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                            </div>
                            <p className="fieldSetting-text">
                                {' '}
                                {getProjectNameOfField(currentFieldData, props.projectList)}
                            </p>
                            {currentFieldData?.affiliationOrganization !== props.corporationDetail.id && (
                                <p className="fieldSetting-text  --3">
                                    {getOrgName(props?.allListCorp ,currentFieldData?.affiliationOrganization)}
                                </p>
                            )}
                        </div>
                        <div className="fieldSetting-autofill">
                            <div
                                className={
                                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                        ? 'fieldSetting-item'
                                        : 'fieldSetting-item background-color-usingForm'
                                }
                            >
                                {!isSystemField(currentFieldData) &&
                                    !isAddNewField(currentFieldData) && (
                                        <>
                                            {isShowDuplicateButton(currentFieldData) && (
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={e => {
                                                        setMoreActionPopover(null);
                                                        if (
                                                            props.parentPanelScreen ===
                                                            Constant.FORM_MANAGEMENT_SCREEN
                                                                .LIST_FIELD
                                                        ) {
                                                            duplicateField(props, currentFieldData);
                                                        } else if (
                                                            [
                                                                'listFieldAddToForm',
                                                                'listFieldInProject'
                                                            ].includes(props.regionDropIdBlock)
                                                        ) {
                                                            duplicateFieldInForm(
                                                                props,
                                                                currentFieldData,
                                                                props.regionDropIdBlock
                                                            );
                                                        }
                                                        if (props.isChangeData === false) props.setIsChangeData(true);
                                                    }}
                                                >
                                                    <img src="/assets/image/icon-copy.svg" alt="" />
                                                </IconButton>
                                            )}

                                            {isPermissionDeleteField(
                                                currentFieldData,
                                                props.formList,
                                                argsAll
                                            ) && (
                                                <IconButton className="itemTools">
                                                    <img
                                                        src="/assets/image/icon-tabs-delete.svg"
                                                        alt=""
                                                        onClick={e => {
                                                            props.handleClick(e);
                                                            props.setCurrentFieldSelected(
                                                                props.currentAddField
                                                            );
                                                            props.setIsOpenConfirmDeleteModal(true);
                                                            props.handleClose();
                                                        }}
                                                    />
                                                </IconButton>
                                            )}

                                            {!props.disableBtnShowMore && (
                                                <IconButton className="itemTools itemTools-arrow" onClick={e =>
                                                    onCloseFieldExpandMore(
                                                        props,
                                                        currentFieldData
                                                    )
                                                }>
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}

                                {!isSystemField(currentFieldData) &&
                                    isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton className="itemTools">
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                    onClick={e => {
                                                        setMoreActionPopover(null);
                                                        removeCurrentGUIAddField(props);
                                                    }}
                                                />
                                            </IconButton>

                                            {!props.disableBtnShowMore && (
                                                <IconButton className="itemTools itemTools-arrow" onClick={e =>
                                                    onCloseFieldExpandMore(
                                                        props,
                                                        currentFieldData
                                                    )
                                                }>
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fieldSetting-content">
                    <FieldIdCommon fieldId={props.currentAddField?.id}/>
                    <div className="lstInput">
                        <p className="lstInput-text">文字数制限</p>
                        <div className="lstInput-control">
                            <div className="lstInput-number">
                                <div className="lstInput-col">
                                    <div className="formNumber">
                                        <TextField
                                            className="form-control-wrapInput form-control-hg32"
                                            variant="outlined"
                                            //type="number"
                                            data-cy="add-text-field-minlength"
                                            // type="number"
                                            defaultValue={currentFieldData.structure.minLength}
                                            value={currentFieldData.structure.minLength}
                                            onChange={e => onChangeMinLength(e)}
                                            error={isFieldError('minLength', currentFieldData)}
                                            helperText={getErrorByField(
                                                'minLength',
                                                currentFieldData
                                            )}
                                            disabled={!isEditField(currentFieldData, argsAll)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment>
                                                        <div className="formButton">
                                                            <Button
                                                                className="btnNumber up"
                                                                onClick={() => {
                                                                    updateFormMinNumber(
                                                                        props,
                                                                        currentFieldData.name,
                                                                        parseInt(currentFieldData.structure
                                                                            .minLength + 1),
                                                                        indexAddField,
                                                                        'length'
                                                                    );
                                                                }}
                                                                disabled={
                                                                    !isEditField(
                                                                        currentFieldData,
                                                                        argsAll
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-arrow-nav.svg"
                                                                    alt=""
                                                                />
                                                            </Button>
                                                            <Button
                                                                className="btnNumber down"
                                                                onClick={() => {
                                                                    updateFormMinNumber(
                                                                        props,
                                                                        currentFieldData.name,
                                                                        parseInt(currentFieldData.structure
                                                                            .minLength - 1),
                                                                        indexAddField,
                                                                        'length'
                                                                    );
                                                                }}
                                                                disabled={
                                                                    !isEditField(
                                                                        currentFieldData,
                                                                        argsAll
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-arrow-nav.svg"
                                                                    alt=""
                                                                />
                                                            </Button>
                                                        </div>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <span className="lstInput-item">~</span>
                                <div className="lstInput-col">
                                    <div className="formNumber">
                                        <TextField
                                            className="form-control-wrapInput form-control-hg32"
                                            variant="outlined"
                                            // type="number"
                                            defaultValue={currentFieldData.structure.maxLength}
                                            value={currentFieldData.structure.maxLength}
                                            onChange={e => onChangeMaxLength(e)}
                                            error={isFieldError('maxLength', currentFieldData)}
                                            helperText={getErrorByField(
                                                'maxLength',
                                                currentFieldData
                                            )}
                                            disabled={!isEditField(currentFieldData, argsAll)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment>
                                                        <div className="formButton">
                                                            <Button
                                                                className="btnNumber up"
                                                                onClick={() => {
                                                                    updateFormMaxNumber(
                                                                        props,
                                                                        currentFieldData.name,
                                                                        parseInt(currentFieldData.structure
                                                                            .maxLength + 1),
                                                                        indexAddField,
                                                                        'length'
                                                                    );
                                                                }}
                                                                disabled={
                                                                    !isEditField(
                                                                        currentFieldData,
                                                                        argsAll
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-arrow-nav.svg"
                                                                    alt=""
                                                                />
                                                            </Button>
                                                            <Button
                                                                className="btnNumber down"
                                                                onClick={() => {
                                                                    updateFormMaxNumber(
                                                                        props,
                                                                        currentFieldData.name,
                                                                        parseInt(currentFieldData.structure
                                                                            .maxLength - 1),
                                                                        indexAddField,
                                                                        'length'
                                                                    );
                                                                }}
                                                                disabled={
                                                                    !isEditField(
                                                                        currentFieldData,
                                                                        argsAll
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/icon-arrow-nav.svg"
                                                                    alt=""
                                                                />
                                                            </Button>
                                                        </div>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lstInput">
                        <p className="lstInput-text">入力書式</p>
                        <div className="lstInput-control">
                            <TextField
                                className="form-control-wrapInput form-control-hg32"
                                variant="outlined"
                                data-cy="add-text-field-regex"
                                onChange={onChangeInputFormat}
                                defaultValue={currentFieldData.structure.inputFormat}
                                disabled={!isEditField(currentFieldData, argsAll)}
                                placeholder="正規表現で入力してください"
                            ></TextField>
                        </div>
                    </div>

                    {/* Share option */}
                    {isDisplayOptionShareField(props?.parentPanelScreen, projectInuseDetail?.id, currentFieldData.affiliationProject, corporationDetail?.rootFlag) && <ShareField {...props} />}

                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                        <SettingFormDev {...props} />
                    )}
                </div>
            </li>
        );
    };

    const isShowContentFieldText = () => {
        const listSysFieldShowContent = ['listOfSynonyms'];

        switch (currentFieldData?.definition) {
            case Constant.FORM_DEFINITION.SYSTEM:
                if(listSysFieldShowContent.includes(currentFieldData?.sysField)) {
                    return true;
                }
                return false;
            default:
                return false;
        }
    }


    const renderSystemField2 = () => {
        return (
            <li id={currentFieldData.id} ref={fieldRef}>
                <div className="fieldSetting-info">
                    <div className="fieldSetting-thumb">
                        <img src={`${getIconFieldByTypeField(currentFieldData)}`} alt="" />
                    </div>
                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name">
                            <p className="fieldSetting-tlt">
                                {Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    currentFieldData.name
                                )}
                            </p>
                            <p className="fieldSetting-text">
                                {getProjectNameOfField(currentFieldData, props.projectList)}
                            </p>
                        </div>
                        <div className="fieldSetting-autofill">
                            <p className="fieldSetting-text">
                                {isSystemField(currentFieldData) && !props.addFormType
                                    ? '自動入力'
                                    : ''}
                            </p>
                            <div className="fieldSetting-item">
                                <IconButton
                                    className="itemTools itemTools-arrow"
                                    onClick={e => onCloseFieldExpandMore(props, currentFieldData)}
                                >
                                    <img src="/assets/image/icon-arrow-accordion-gray.svg" alt="" />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>

                {isShowContentFieldText() ? (
                    <div className="fieldSetting-content">
                        <FieldIdCommon fieldId={props.currentAddField?.id} />
                        <div className="lstInput">
                            <p className="lstInput-text">文字数制限</p>
                            <div className="lstInput-control">
                                <div className="lstInput-number">
                                    <div className="lstInput-col">
                                        <div className="formNumber">
                                            <TextField
                                                className="form-control-wrapInput form-control-hg32"
                                                variant="outlined"
                                                data-cy="add-text-field-minlength"
                                                value={
                                                    currentFieldData.structure.minLength
                                                        ? currentFieldData.structure.minLength
                                                        : 0
                                                }
                                                disabled={true}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment>
                                                            <div className="formButton">
                                                                <Button
                                                                    className="btnNumber up"
                                                                    disabled={true}
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                                <Button
                                                                    className="btnNumber down"
                                                                    disabled={true}
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                            </div>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <span className="lstInput-item">~</span>
                                    <div className="lstInput-col">
                                        <div className="formNumber">
                                            <TextField
                                                className="form-control-wrapInput form-control-hg32"
                                                variant="outlined"
                                                defaultValue={currentFieldData.structure.maxLength}
                                                value={currentFieldData.structure.maxLength}
                                                disabled={true}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment>
                                                            <div className="formButton">
                                                                <Button
                                                                    className="btnNumber up"
                                                                    disabled={true}
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                                <Button
                                                                    className="btnNumber down"
                                                                    disabled={true}
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                            </div>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lstInput">
                            <p className="lstInput-text">入力書式</p>
                            <div className="lstInput-control">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    data-cy="add-text-field-regex"
                                    onChange={onChangeInputFormat}
                                    defaultValue={currentFieldData.structure.inputFormat}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    placeholder="正規表現で入力してください"
                                ></TextField>
                            </div>
                        </div>
                    </div>
                ) : (
                    <FieldIdCommon fieldId={props.currentAddField?.id} />
                )}

                {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                    props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                    <SettingFormDev {...props} />
                )}
            </li>
        );
    };

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <>
                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) &&
                        isSystemField(currentFieldData) &&
                        renderSystemField2()}
                    {!isSystemField(currentFieldData) && renderCustomField()}
                </>
            )}
        </>
    );
}
